// extracted by mini-css-extract-plugin
export var closeButton = "_ml-1";
export var closeX = "_ml-3";
export var container = "_ml-0";
export var image = "_ml-2";